const listenTimeout = 5000;

const trackerObject = {
  "CREATE_ORDER": {
    startListening:false,
    invoked:false,
    listenTimeout:8000,
    validationErrorSelectors:['.shipping-accordion .TextBox__error','.pickup-accordion .TextBox__error','.payment-accordion .TextBox__error'],
  },
  "ADD_GIFT_CARD": {
    startListening:false,
    invoked:false,
    listenTimeout,
    validationErrorSelectors:['.gift-addgiftcard-container .TextBox__error'],
  },
  "ADD_PAYMENT_INSTRUMENTS": {
    startListening:false,
    invoked:false,
    listenTimeout,
    validationErrorSelectors:['.credit-card-container .TextBox__error','.plcc-card-container .TextBox__error'],
  },
  "UPDATE_SHIPPING_DETAILS": {
    startListening:false,
    invoked:false,
    listenTimeout:6000,
    validationErrorSelectors:['.shipping-accordion .TextBox__error'],
  }
};



export default trackerObject;
